import React, { useEffect, useState } from 'react';
import data from './data/data.json';

const DataTable = () => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(data);
  }, []);

  return (
    <div className='h-[80mm] text-sm border-l border-r border-black grid grid-rows-[auto_repeat(12,_auto)]'>
      <div className='h-[14mm] grid grid-cols-[20mm_73mm_20mm_20mm_20mm_25mm_20mm] b_border'>
        <div className='w_center r_border'>일자</div>
        <div className='w_center r_border'>품목명[규격]</div>
        <div className='w_center r_border'>수량</div>
        <div className='w_center r_border'>단위</div>
        <div className='w_center r_border'>단가</div>
        <div className='w_center r_border'>공급가액</div>
        <div className='w_center'>부가세</div>
      </div>

      {/* 반복되는 행들 */}
      {tableData.map((row, index) => (
        <div
          key={index}
          className='h-[5.5mm] grid grid-cols-[20mm_73mm_20mm_20mm_20mm_25mm_20mm] border-b border-black'
        >
          <div className='w_center r_border'>{row.date}</div>
          <div className='flex justify-start items-center r_border pl-[4mm]'>{row.item}</div>
          <div className='flex justify-end items-center r_border pr-[2mm]'>{row.quantity}</div>
          <div className='flex justify-end items-center r_border pr-[2mm]'>{row.unit}</div>
          <div className='flex justify-end items-center r_border pr-[2mm]'>{row.price}</div>
          <div className='flex justify-end items-center r_border pr-[2mm]'>{row.total}</div>
          <div className='flex justify-end items-center pr-[2mm]'>{row.vat}</div>
        </div>
      ))}
    </div>
  );
};

export default DataTable;
